// A cancelled event is kept (status CANCELLED) and still opens by ID: event details send eventStatus "Cancelled",
// and every notification about it links to /attendieViewbeforeJoin/<id>?status=cancelled. The page then shows
// the cancelled state (EventCancelledBanner) with the actions hidden.
// The status param is a fallback for a response without eventStatus; a cancelled event never comes back.
export const isEventCancelled = (event, search = "") =>
  String(event?.eventStatus || "").toUpperCase() === "CANCELLED" ||
  new URLSearchParams(search).get("status")?.toLowerCase() === "cancelled";

// Events deleted before that change are gone, and their old notifications still point at a list page
// (CMPSDT-1073). Those open the list instead, and this popup explains why. It's owned by the app
// (EventCancelledNotice, mounted in App.js) so it stays on screen after the notification page navigates away.

export const EVENT_CANCELLED_MESSAGE = "This event has been cancelled and is no longer available.";

export const EVENT_CANCELLED_NOTICE_EVENT = "eventCancelledNotice";

// message: the notification's own sentence ("<College> cancelled an event."); eventName: shown above it when known
export const showEventCancelledNotice = ({ message, eventName } = {}) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(EVENT_CANCELLED_NOTICE_EVENT, {
      detail: { message: message || EVENT_CANCELLED_MESSAGE, eventName: eventName || "" },
    }),
  );
};
